import {withHandlers} from 'recompose'

import compose from 'lodash/flowRight'
import {Suspense} from 'react'
import {connect} from 'react-redux'

import {assignProblemInvestigations, openDialog} from '../../../../../../actions'
import {withBuildId} from '../../../../../../hooks/routes'
import type {State} from '../../../../../../reducers/types'
import {getBuild, getBuildType} from '../../../../../../selectors'
import {emptyArray} from '../../../../../../utils/empty'
import {getInvestigationInCurrentScope} from '../../../../../common/Investigations/Investigations.selectors'
import {fetchProblemOccurrence} from '../../../BuildProblems.actions'

import BuildProblemActions from './BuildProblemActions'
import type {
  OwnProps,
  ComposeProps,
  StateProps,
  ActionProps,
  Props,
} from './BuildProblemActions.types'

const mapStateToProps = (
  state: State,
  {buildId, problemOccurrence}: OwnProps & ComposeProps,
): StateProps => {
  const build = getBuild(state, buildId)
  const buildType = getBuildType(state, build?.buildType)
  const problemProjectId = getBuildType(state, problemOccurrence.build?.buildTypeId)?.projectId
  const investigations = problemOccurrence.problem?.investigations?.investigation ?? emptyArray
  return {
    problemProjectId,
    problemBuildId: problemOccurrence.build?.id,
    investigationInCurrentScope: getInvestigationInCurrentScope(
      state,
      investigations,
      buildType?.projectId,
      buildType?.id,
    ),
  }
}

const actionCreators: ActionProps = {
  fetchProblemOccurrence,
  assignProblemInvestigations,
  openDialog,
}
export default compose(
  withBuildId,
  connect(mapStateToProps, actionCreators),
  withHandlers({
    assignInvestigationHandler:
      ({
        assignProblemInvestigations: assign,
        fetchProblemOccurrence: fetch,
        problemBuildId,
        problemOccurrence,
      }: Props) =>
      (presetFix: boolean) =>
        problemBuildId != null &&
        problemOccurrence.problem?.id != null &&
        assign(problemOccurrence.problem.id, problemBuildId, presetFix, () =>
          fetch(problemOccurrence.id!),
        ),
  }),
)(function BuildProblemActionsContainer(props: Props) {
  return (
    <Suspense>
      <BuildProblemActions {...props} />
    </Suspense>
  )
})
